export const UBII_PAGO_RATE_LIMIT_COOLDOWN_SECONDS = 10 * 60;
export const UBII_PAGO_MAX_ATTEMPTS = 10;

export const UBII_PAGO_REFERENCE_LENGTH = 6;

export function formatUbiiPagoCountdown(totalSeconds) {
  const safe = Math.max(0, totalSeconds);
  const minutes = Math.floor(safe / 60);
  const seconds = safe % 60;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}

/**
 * Normaliza el input de monto:
 * - acepta dígitos y separadores `,` o `.`
 * - unifica `.` -> `,`
 * - permite máx. 2 decimales
 * - devuelve `null` si el input no cumple patrón permitido
 *
 * IMPORTANTE: se conserva la coma mientras escribe (ej. `100,`).
 *
 * @returns {string|null} cadena normalizada, "" (vacío) o null (inválido)
 */
export function normalizeUbiiPagoAmountInput(raw) {
  if (raw === "") return "";

  const cleaned = String(raw).replace(/[^\d.,]/g, "").replace(/\./g, ",");
  const parts = cleaned.split(",");

  if (parts.length === 1) {
    return /^\d*$/.test(parts[0]) ? parts[0] : null;
  }

  const intPart = parts[0] ?? "";
  const fracPart = parts.slice(1).join("").slice(0, 2);
  if (!/^\d*$/.test(intPart) || !/^\d*$/.test(fracPart)) return null;

  return `${intPart},${fracPart}`;
}

export function parseUbiiPagoAmount(raw) {
  const normalized = String(raw).replace(",", ".").trim();
  if (!normalized || normalized === ".") return Number.NaN;
  return Number(normalized);
}

export function isValidUbiiPagoAmount(amount) {
  if (!Number.isFinite(amount) || amount <= 0) return false;
  const scaled = amount * 100;
  return Math.abs(scaled - Math.round(scaled)) < 1e-8;
}

export function toUbiiPagoAmountCents(amount) {
  return Math.round(amount * 100);
}

export function normalizeUbiiPagoReferenceInput(raw) {
  return String(raw).replace(/\D/g, "").slice(-UBII_PAGO_REFERENCE_LENGTH);
}

export function normalizeUbiiPagoReference(reference) {
  return normalizeUbiiPagoReferenceInput(reference);
}

export function isValidUbiiPagoReference(reference) {
  return new RegExp(`^\\d{${UBII_PAGO_REFERENCE_LENGTH}}$`).test(normalizeUbiiPagoReference(reference));
}

export function getUbiiPagoClaimErrorKey(httpStatus) {
  switch (httpStatus) {
    case 400:
      return "ubiiPagoClaimErrorInvalid";
    case 404:
      return "ubiiPagoClaimErrorNotFound";
    case 422:
      return "ubiiPagoClaimErrorManualReview";
    case 429:
      return "ubiiPagoClaimErrorRateLimit";
    default:
      return "ubiiPagoClaimErrorGeneric";
  }
}

